import { BranchGetUseCase } from '../../../../application';

export default class BranchGetService {

    async execute(event) {
        const data = await BranchGetUseCase(event);
        return data;
    }
}
